import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async store(campaignId: number, catalogId: number): Promise<any> {
    return await this.call(`/spa/campaigns/${campaignId}/catalogs/${catalogId}`, {
      method: 'post',
    })
  }

  async delete(campaignId: number, catalogId: number): Promise<any> {
    return await this.call(`/spa/campaigns/${campaignId}/catalogs/${catalogId}`, {
      method: 'delete',
    })
  }
}
